export const telReg = /^[1][3,4,5,7,8][0-9]{9}$/; //手机号
export const telReg1 = /^[0-9]{10}$/; //越南手机号
export const emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ //邮箱
export const accountReg = /^[A-Za-z0-9]{5,15}$/; //登录账号
export const passwordReg = /^[A-Za-z0-9]{16,32}$/; //登录密码
export const passwordReg2 = /^[A-Za-z0-9]{6,32}$/; //登录密码
export const captchaReg = /^[A-Za-z0-9]{5}$/; //验证码
export const codeReg = /^[A-Za-z0-9]{3,8}$/; //平台代码
export const orderIdReg = /^[A-Za-z0-9]{24}$/; //订单号 24位字母数字

export const ipReg = /^(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])$/;
export const ipSearchReg = /^((\d|[1-9]\d|1\d{2}|2[0-5][0-5])|(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])|(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])|(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5])\.(\d|[1-9]\d|1\d{2}|2[0-5][0-5]))$/;

export const positiveIntegerReg = /^([1-9][0-9]*)$/;//正整数
export const numberLetterReg = /^([A-Za-z0-9]*)$/;
export const decimal2Reg = /^(([1-9][0-9]*)|0)+\.?\d{0,2}$/;
export const decimal4Reg = /^(([1-9][0-9]*)|0)+\.?\d{0,4}$/;
export const positiveIntegerAmountReg = /^(([1-9][0-9]{0,17})|0)$/;
export const integerReg8 = /^(([0-9]{0,8})|1)$/; //纯数字校验1-8
export const integerReg = /^(([1-9][0-9]{0,9})|1)$/; //纯数字校验1-10
export const countReg = /^((([1-9][0-9]{0,2}))|0)$/;
export const ipList = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))|\*)((\/(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]))?)(,((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))|\*)((\/(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]))?))*$/;
export const ipSection = /^(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))-(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))$/;
export const versionReg = /^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/; //版本号 x.x.x的形式，每位x的范围分别为1-99,0-99,0-99

export const amountReg1 = /^([1-9][0-9]*)$/;
